import { FileText, Search, Handshake, ClipboardCheck, LifeBuoy } from "lucide-react";
import { Container, Reveal } from "@/components/Reveal";

const STEPS = [
  { Icon: FileText, title: "Tell Us About Your Business", text: "Share a recent energy bill and your goals. It only takes a few minutes." },
  { Icon: Search, title: "We Compare Suppliers", text: "We shop your usage across our network of licensed electricity and gas suppliers." },
  { Icon: Handshake, title: "We Negotiate Terms", text: "We negotiate competitive rates and contract terms on your behalf." },
  { Icon: ClipboardCheck, title: "You Choose the Best Fit", text: "We present clear, side-by-side options so you can decide with confidence." },
  { Icon: LifeBuoy, title: "We Support You Ongoing", text: "We track renewals and market timing so your business never overpays." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-ice py-20 md:py-24" data-testid="how-it-works">
      <Container>
        <div className="mx-auto max-w-2xl text-center">
          <p className="overline text-electric">Energy Brokering</p>
          <h2 className="mt-4 font-heading text-3xl font-semibold tracking-tight text-navy md:text-4xl">
            From your energy bill to a better deal in five steps.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slatey">
            We handle the market legwork so you don't have to. Independent, transparent,
            and always working in your best interest.
          </p>
          <div className="mt-6 flex justify-center">
            <span
              data-testid="no-cost-badge"
              className="inline-flex items-center gap-2 rounded-full border border-energy/30 bg-energy/10 px-4 py-1.5 font-mono text-xs font-semibold uppercase tracking-[0.14em] text-energy"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-energy" />
              No cost to you
            </span>
          </div>
        </div>

        <div className="relative mt-16">
          <div className="absolute left-0 right-0 top-7 hidden h-px bg-line lg:block" />
          <div className="relative grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
            {STEPS.map(({ Icon, title, text }, i) => (
              <Reveal key={title} delay={i * 0.08}>
                <div
                  className="flex flex-col items-center text-center"
                  data-testid={`step-${i + 1}`}
                >
                  <div className="relative">
                    <span className="flex h-14 w-14 items-center justify-center rounded-full border border-line bg-ice text-navy">
                      <Icon className="h-6 w-6" />
                    </span>
                    <span className="absolute -right-1.5 -top-1.5 flex h-6 w-6 items-center justify-center rounded-full bg-electric font-mono text-xs font-semibold text-white">
                      {i + 1}
                    </span>
                  </div>
                  <h3 className="mt-5 font-heading text-base font-semibold text-navy">{title}</h3>
                  <p className="mt-2 max-w-[15rem] text-sm leading-relaxed text-slatey">{text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
